import { Guid, Nillable } from '@web/utils';
import { Permission } from '../enums/permission';
import { Role } from '../enums/role';

export class UserContext {
  public constructor(
    private readonly data: {
      avatar: Nillable<string>;
      displayName: string;
      email: string;
      firstName?: Nillable<string>;
      id: Guid;
      lastName?: Nillable<string>;
      permissions: Permission[];
      username: string;
      roles: Role[];
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get email(): string {
    return this.data.email;
  }

  public get username(): string {
    return this.data.username;
  }

  public get avatar(): Nillable<string> {
    return this.data.avatar;
  }

  public get firstName(): Nillable<string> {
    return this.data.firstName;
  }

  public get lastName(): Nillable<string> {
    return this.data.lastName;
  }

  public get displayName(): string {
    return this.data.displayName;
  }

  public get permissions(): Permission[] {
    return this.data.permissions;
  }

  public get roles(): Role[] {
    return this.data.roles;
  }
}
